import { ProviderConfig, ProviderTypes } from 'types';
import { KineticTheme } from 'config/themes';

export const Windstream: ProviderConfig = {
  providerType: ProviderTypes.LEC,
  providerCode: 'windstream', // Not changed during rebrand from Windstream -> Kinetic
  dcCode: 'Windstream', // Not changed during rebrand from Windstream -> Kinetic
  name: 'Windstream', // Not changed during rebrand from Windstream -> Kinetic
  displayName: 'Kinetic',
  reskinTheme: KineticTheme,
  reskinTitle: 'Kinetic Authorized Dealer',
  showPricingDisclaimer: false,
  broadbandDisplayType: 'linkout_url',
};
